import React, {
    useContext,
    useEffect,
} from "react"

import {
    useLocation,
} from "react-router-dom"

import {
    EMETLPerformanceStepRating, 
    PerformanceStepFlat,
} from "../Model/EMETLAssessment.m"

import {
    Context, 
    EMETLContext,
} from "../Model/Contexts/AppContext"

import VM from "../ViewModel/AssessmentTaskPerformanceSteps.vm"
import EMETLAssessmentDetailsPS from "./Components/EMETLAssessmentDetailsPS"

import { 
    AssessmentTaskPerformanceStep, 
} from "../API"
import EMETLNavButton from "./Components/EMETLNavButton"


const AssessmentTaskPerformanceSteps = () => {
    VM.ctx = useContext(Context)

    const {
        amplify,
        staticTasksAndPS: {
            value: t,
        },
        loading: {
            setMessage,
            update: setLoading,
        }
    } = VM.ctx as EMETLContext

    const [performanceSteps, setPerformanceSteps] = React.useState<AssessmentTaskPerformanceStep[]>([])
    const location = useLocation()
    
    const {
        atID,
        taskNumber,
    } = location.state || {} 


    const load = async () => {
        if (atID) {
            setMessage("Loading performance steps")
            setLoading(true)
            const resp = await VM.loadPerformanceStepsForAssessmentTask(atID)
            setMessage("")
            setLoading(false)

            if (resp)
                setPerformanceSteps(resp)    
        }
    }

    const save = async (psID: number, rating: EMETLPerformanceStepRating, needs: string) => {
        const existingPSData = performanceSteps?.find(ps => ps.PSID === psID)
       
        let resp = null
        if (existingPSData) {
            setMessage("Updating performance step")
            setLoading(true)
            resp = await VM.updateAssessmentTaskPerformanceStep({
                ...existingPSData,
                Rating: rating,
                SpecificNeeds: needs,
            })   
            setMessage("")
            setLoading(false)
        } else {
            setMessage("Creating performance step")
            setLoading(true)
            resp = await VM.createAssessmentTaskPerformanceStep({
                ATID: atID,
                PSID: psID,
                Rating: rating,
                SpecificNeeds: needs,
            })
            setMessage("")
            setLoading(false)
        }
        if (resp) {
            setPerformanceSteps(performanceSteps.map(ps => ps.PSID === psID ? resp : ps))
        } else {
            return false
        }

        return true
    }

    useEffect(() => {
        if (amplify) {
            VM.db = amplify
            load()
        }
    }, [amplify, t])

    return (
        <>
            {taskNumber && (
                <h3 className="m-4">
                    Performance Steps for {taskNumber}
                </h3>
            )}
            <EMETLNavButton
                onClick={() => history.back()}
                style={{
                    marginLeft: 25,
                }}
            >
                Go Back
            </EMETLNavButton>
            <div
                style={{
                    padding: "30px"
                }}
            >
                {!!Object.keys(t)?.length && taskNumber ? t[taskNumber]?.map(
                    (k: PerformanceStepFlat) => {
                        const existingPSData = performanceSteps?.find(ps => ps.PSID === k.PSID)

                        return (
                            <EMETLAssessmentDetailsPS
                                key={k.PSID}
                                step={{
                                    ...k,
                                    ...existingPSData,
                                }}
                                onSave={async (...rest) => {
                                    const r = await save(...rest)
                                    await load()
                                    
                                    return r
                                }}
                                needs={existingPSData?.SpecificNeeds}
                                rating={existingPSData?.Rating}
                            />
                        )
                    }
                ) : (
                    <h4 className="text-secondary">No performance steps are assigned to this assessment task.</h4>
                )}
            </div>
        </>
    )
}

export default AssessmentTaskPerformanceSteps